import { CombinedGraphQLErrors, ServerError } from '@apollo/client/errors';

const AUTH_INVALID_CODES = new Set(['UNAUTHENTICATED', 'FORBIDDEN']);

const hasAuthInvalidGraphQLError = (error: unknown): boolean => {
  if (!CombinedGraphQLErrors.is(error)) return false;

  return error.errors.some((graphQLError) => {
    const code = graphQLError.extensions?.code;
    return typeof code === 'string' && AUTH_INVALID_CODES.has(code.toUpperCase());
  });
};

const hasAuthInvalidNetworkError = (error: unknown): boolean => {
  if (!ServerError.is(error)) return false;
  return error.statusCode === 401 || error.statusCode === 403;
};

export const shouldLogoutForAuthInvalidState = (error: unknown): boolean => {
  return hasAuthInvalidNetworkError(error) || hasAuthInvalidGraphQLError(error);
};
